/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`
export default class ReplyIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" css={Color}>
        <g id="그룹_5463" data-name="그룹 5463" transform="translate(-1089.159 -1348.723)">
          <rect id="사각형_5456" data-name="사각형 5456" width="22" height="22" transform="translate(1089.159 1348.723)" fill="#fff" opacity="0"/>
          <path id="패스_5234" data-name="패스 5234" d="M1099.99,1351.227c-4.925,0-8.931,3.625-8.931,8.082a7.458,7.458,0,0,0,1.338,4.256,6.126,6.126,0,0,1-1.126,3.441.723.723,0,0,0,.612,1.226,15.747,15.747,0,0,0,4.672-1.461,9.653,9.653,0,0,0,3.41.619h.025c4.923,0,8.929-3.625,8.929-8.081S1104.913,1351.227,1099.99,1351.227Zm-6.133,12.2a.72.72,0,0,0-.14-.49,6.132,6.132,0,0,1-1.217-3.623c0-3.659,3.358-6.636,7.485-6.636s7.486,2.977,7.486,6.636-3.356,6.629-7.48,6.63a9.091,9.091,0,0,1-2.821-.492l-.089-.037a1.065,1.065,0,0,0-1.066,0,10.574,10.574,0,0,1-2.794,1.079A11.258,11.258,0,0,0,1093.857,1363.427Z" fill="#5c5c5c"/>
          <path id="패스_5235" data-name="패스 5235" d="M1104,1359.521l-.013-.069a.2.2,0,0,0-.018-.057c-.007-.02-.012-.03-.017-.042l-.019-.037-.026-.045-2.479-2.807a.7.7,0,0,0-.483-.235.711.711,0,0,0-.508.176.7.7,0,0,0-.059.991l1.37,1.542h-4.992a.7.7,0,1,0,.006,1.4h4.986l-1.369,1.542a.7.7,0,0,0,.523,1.169l.042,0a.7.7,0,0,0,.484-.235l2.405-2.706.042-.053a.186.186,0,0,0,.034-.044l.026-.046a.294.294,0,0,0,.016-.033.453.453,0,0,0,.021-.052l.013-.04.006-.048c.015-.028.016-.054.012-.054a.133.133,0,0,0,.007-.078v-.074A.127.127,0,0,0,1104,1359.521Z" fill="#5c5c5c"/>
        </g>
      </svg>
    )
  }
}
